// extracted by css-extract-rspack-plugin
export default {"formWrapper":"MultiStepAddOrganization_formWrapper__hnujL"};